import { render, staticRenderFns } from "./VaultSettingsNavMobile.vue?vue&type=template&id=61f78370"
import script from "./VaultSettingsNavMobile.vue?vue&type=script&lang=js"
export * from "./VaultSettingsNavMobile.vue?vue&type=script&lang=js"
import style0 from "./VaultSettingsNavMobile.vue?vue&type=style&index=0&id=61f78370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports